export const SocketAction = {
  MESSAGE: "action://message",
  WEB_MESSAGE: "action://web-message",
  NOTIFICATION: "action://notification",
  CONVERSATION: "action://conversation",
  CONVERSATION_STATUS: "action://conversation-status-change",
  SOCIAL_POST: "action://socialPost",
  SUBSCRIBE: "action://subscribe",
  LEAVE: "action://leave",
  CLIENT_SUBSCRIBE: "action://client-subscribe",
  ONLINE: "action://online",
  OFFLINE: "action://offline",
  DISCONECTING: "disconnecting",
  WEMBII_SUPPORT_SUBSCRIBE: "action://wembii-support-subscribe",
  WEMBII_SUPPORT_CLIENT_SUBSCRIBE: "action://wembii-support-client-subscribe",
  WEMBII_SUPPORT_MESSAGE: "action://wembii-support-message",
  WEMBII_SUPPORT_CONVERSATION: "action://wembii-support-conversation",
  WEMBII_SUPPORT_VISITOR_ONLINE: "action://wembii-support-visitor-online",
  WEMBII_SUPPORT_VISITOR_OFFLINE: "action://wembii-support-visitor-offline",
  WEMBII_SUPPORT_CLIENT_DISCONNECT: "action://wembii-support-client-disconnect",
  WEMBII_SUPPORT_AGENTS_ONLINE: "action://wembii-support-agents-online",
}
